export enum VgsDrawerColorScheme {
  Black = 'black',
  Blue = 'blue',
  Orange = 'orange',
  Violet = 'violet',
}

export default VgsDrawerColorScheme
